module.exports = __webpack_public_path__ + "img/dat_icon.1a938189.svg";